module.exports = __webpack_public_path__ + "static/media/carouselImage.895af3cf.jpg";